import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Group, Text } from '@mantine/core';

interface GateBannerProps {
  readonly icon: ReactNode;
  readonly to: string;
  readonly title: string;
  readonly text: string;
  readonly action: string;
}

// Общий баннер-ограничение: пшеничный Alert с заголовком, пояснением и кнопкой-диплинком в нужный
// раздел «Моей компании». Единый вид для ограничений «до подписания агентского договора», «до
// аттестации» и т.п. (см. AgencyGateBanner, AttestationGateBanner). Презентационный — весь текст и
// маршрут задаёт вызывающий.
export default function GateBanner({ icon, to, title, text, action }: GateBannerProps) {
  return (
    <Alert color="wheat" variant="light" icon={icon}>
      <Group justify="space-between" wrap="wrap" gap="sm" align="center">
        <div style={{ minWidth: 0, flex: 1 }}>
          <Text fw={600}>{title}</Text>
          <Text size="sm" c="gray.8">
            {text}
          </Text>
        </div>
        <Button component={Link} to={to} variant="filled" color="lime.4" c="brand.9" style={{ flexShrink: 0 }}>
          {action}
        </Button>
      </Group>
    </Alert>
  );
}
